import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useAccessImperativeHandle } from "@/hooks/useAccessImperativeHandle";
import { useEffect, useRef } from "react";
import { CreateOrganizationModalProps } from ".";
import { OrganizationForm, OrganizationFormRef } from "../OrganizationForm";

export function CreateOrganizationModal({ open, onOpenChange, onSubmitHandler }: Readonly<CreateOrganizationModalProps>) {
    const organizationFormRef = useRef<OrganizationFormRef>(null);
    const resolvedOrganizationFormRef = useAccessImperativeHandle(organizationFormRef)
    useEffect(() => {
        if (open) {
            resolvedOrganizationFormRef?.resetForm()
        }
    }, [resolvedOrganizationFormRef, open])
    return (
        <Dialog open={open} onOpenChange={onOpenChange} defaultOpen={false}>
            <DialogContent className="">
                <DialogHeader>
                    <DialogTitle className='ps-1'>
                        <div className="p-0 m-0 text-start fw-bold">
                            Create New Organization
                        </div>
                    </DialogTitle>
                </DialogHeader>
                <OrganizationForm ref={organizationFormRef} />
                <DialogFooter>
                    <div className="flex justify-end gap-2">
                        <Button
                            size="sm"
                            type="button"
                            variant="secondary"
                            onClick={() => onOpenChange(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            size="sm"
                            type="submit"
                            disabled={!resolvedOrganizationFormRef}
                            onClick={() => resolvedOrganizationFormRef!.form.handleSubmit(onSubmitHandler)()}
                        >
                            Submit
                        </Button>
                    </div>
                </DialogFooter>
            </DialogContent>
        </Dialog >
    )
}